import _ from "lodash";
import creditCardType, { getTypeInfo } from "credit-card-type";
import configureStore from "../Store/ConfigureStore";
import Constants from "../AppConstants/Constants";

export default class Utilities {
    static serializeJson(json) {
        const formData = new FormData();

        this.appendFormdata(formData, json);

        return formData;
    }

    static appendFormdata(FormData, data, name) {
        name = name || "";
        if (typeof data === "object") {
            _.each(data, (value, key) => {
                if (name === "") {
                    this.appendFormdata(FormData, value, key);
                } else {
                    this.appendFormdata(FormData, value, `${name}[${key}]`);
                }
            })
        } else if (data !== null && data !== undefined) {
            FormData.append(name, data);
        }
    }

    static toTitleCase(str) {
        return str.replace(/\w\S*/g, function(txt){
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }

    static getQueryStringParameters(url) {
        // TimT: https://stackoverflow.com/questions/7722683/how-to-get-all-querystring-values-using-javascript
        const vars = [];
        let hash;
        const hashes = url.slice(url.indexOf("?") + 1).split("&");
        for (let i = 0; i < hashes.length; i++) {
            if (hashes[i].includes("=")) {
                hash = hashes[i].split("=");
                // vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }
        }
        return vars;
    }

    static scrollToTop(animate) {
        if (animate) {
            $("html, body").animate({ scrollTop: 0 });
        } else {
            window.scrollTo(0, 0);
        }
        return false;
    }

    static getValueFromPriceString(price) {
        const state = configureStore.getState();
        const targetCurrency = state.activeCurrency;

        if (price.includes(" ")) {
            price = price.replace(/ /g, "");
        }

        if (targetCurrency.currencySymbol) {
            const symbol = targetCurrency.currencySymbol.replace(/(0\.00|0,00)/, "").trim();
            price = price.replace(symbol, "").trim();
        } else {
            price = price.replace("$", "").trim();
        }

        if (price.includes(",")) {
            price = price.replace(/,/g, "");
        }


        return parseFloat(price);
    }

    static formatNumber(value, decimals = 2, languageCode = null) {
        const state = configureStore.getState();

        if (!languageCode) {
            languageCode = state.i18n.locale;
        }

        if (value === undefined || value === null) {
            return null;
        }

        let number = value;

        if (number.constructor === String) {
            number = Utilities.getValueFromPriceString(value);
        }

        switch (languageCode) {
        case "fr-CA":
            return _.round(number, decimals).toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(".", ",");
        default:
            return _.round(number, decimals).toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }

    static formatPrice(value, decimals = 2) {
        const state = configureStore.getState();
        const targetLanguage = state.i18n.locale;
        const targetCurrency = state.activeCurrency;

        if (value === undefined || value === null) {
            return null;
        }

        let number = Utilities.formatNumber(value, decimals);

        if (targetCurrency.currencySymbol) {
            return targetCurrency.currencySymbol.replace(/(0\.00|0,00)/, number);
        }

        // Default behavior: show in current locale's format
        switch (targetLanguage) {
        case "fr-CA":
            return `${number} $`;
        default:
            return `$${number}`;
        }
    }

    static convertToPrimaryStoreCurrency(amount) {
        const state = configureStore.getState();
        const sourceCurrency = state.activeCurrency;

        return Utilities.convertCurrency(amount, sourceCurrency, Constants.DEFAULT_CURRENCY);
    }

    static convertFromPrimaryStoreCurrency(amount) {
        const state = configureStore.getState();
        const targetCurrency = state.activeCurrency;

        return Utilities.convertCurrency(amount, Constants.DEFAULT_CURRENCY, targetCurrency);
    }

    static convertCurrency(value, sourceCurrency, targetCurrency) {
        let result = value;

        if (result.constructor === String) {
            result = Utilities.getValueFromPriceString(value);
        }

        if (result === 0 || sourceCurrency.id === targetCurrency.id) {
            return result;
        }

        const rate = targetCurrency.rate / sourceCurrency.rate;

        result *= rate;

        return result;
    }

    /**
     * Decode a string carried in a MessageEvent body field.
     *
     * @param str the string to be decoded
     * @returns the decoded string
     */
    static decodeString(str) {
        str = decodeURIComponent(str.replace(/\+/g, " "));
        str = str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/\'/g, "&#x27;").replace(/\//g, "&#x2f;");

        return str;
    }

    static isBlank(s) {
        return !s || s.replace(/\s/g, "").length === 0;
    }

    static trim(s) {
        if (!s) {
            return "";
        }

        return s.replace(/^\s+|\s+$/g, "");
    }

    static normalizePhone(values) {
        if (!values) {
            return values
        }

        const onlyNums = values.replace(/[^\d]/g, "");
        if (onlyNums.length <= 3) {
            return onlyNums
        }
        if (onlyNums.length <= 7) {
            return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3)}`
        }
        return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 6)}-${onlyNums.slice(
            6,
            10
        )}`
    }

    static normalizeCreditCard(value) {
        const onlyNums = value.replace(/[^\d]/g, "");
        const card = creditCardType(onlyNums);
        const type = card[0] ? card[0].type : "visa";
        const length = card[0] ? card[0].lengths[0]: 3;

        if (onlyNums === "") {
            return onlyNums;
        } else if (onlyNums.length > length) {
            return prettyCardNumber(onlyNums.slice(0, length), type);
        } else {
            return prettyCardNumber(onlyNums, type);
        }

        function prettyCardNumber(cardNumber, cardType) {
            const card = getTypeInfo(cardType);

            if (card) {
                const offsets = [0].concat(card.gaps).concat([cardNumber.length]);
                const components = [];

                for (let i = 0; offsets[i] < cardNumber.length; i++) {
                    const start = offsets[i];
                    const end = Math.min(offsets[i + 1], cardNumber.length);
                    components.push(cardNumber.substring(start, end));
                }

                return components.join(" ");
            }

            return cardNumber;
        }
    }

    static normalizeCvv(value, cardType) {
        const onlyNums = value.replace(/[^\d]/g, "");
        const card = creditCardType.getTypeInfo(cardType);
        const length = card.code.size;

        if (onlyNums.length > length) {
            return onlyNums.slice(0, length);
        } else {
            return onlyNums;
        }
    }

    static normalizeABA(value) {
        const length = 9;
        const onlyNums = value.replace(/[^\d]/g, "");

        if (onlyNums.length > length) {
            return onlyNums.slice(0, length);
        } else {
            return onlyNums;
        }
    }

    static normalizeACH(value) {
        const length = 17;
        const onlyNums = value.replace(/[^\d]/g, "");

        if (onlyNums.length > length) {
            return onlyNums.slice(0, length);
        } else {
            return onlyNums;
        }
    }

    static normalizeAccountName(value) {
        const length = 22;

        if (value.length > length) {
            return value.slice(0, length);
        } else {
            return value;
        }
    }

    static buildUrlQueryString(params) {
        return Object.keys(params)
            .filter(k => params[k])
            .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
            .join("&");
    }

    static showFile(blob, name) {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        const newBlob = new Blob([blob], { type: "application/pdf" })

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
        }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement("a");
        link.href = data;
        link.download = `${name}.pdf`;
        document.body.appendChild(link);
        link.click();
        setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
            document.body.removeChild(link);
            window.URL.revokeObjectURL(data);
        }, 100);
    }

    static buildUrl(url, addExpiresParam = false) {
        const state = configureStore.getState();
        const qs = Utilities.getQueryStringParameters(url);
        const languageCode = state.i18n.locale;

        if (Object.keys(qs).length > 0) {
            url += `&culture=${languageCode}`;
        } else {
            url += `?culture=${languageCode}`;
        }

        if (addExpiresParam) {
            url += `&expires=${Date.now()}`;
        }

        return url;
    }
}